import axios from 'axios'
import { apiBaseUrl, isDev, config } from '@/config/config'
import csrfService from './csrf'
import i18n from '@/i18n'
import Vue from 'vue'

const successCode = config.successCode

// 请求失败后的错误统一处理
const netErrorHandle = (status, errorCode, msg) => {
  switch (status) {
    case 401:
      if (msg) {
        console.error(msg)
        // 401错误显示不自动消失的弹框，带重新登录按钮
        Vue.prototype.$message.error({
          message: msg,
          duration: 0, // 不自动消失
          showClose: true,
          actions: [
            {
              text: i18n.t('common.reLogin'),
              type: 'primary',
              handler: () => {
                // 跳转到登录页面
                const currentPath = window.location.pathname + window.location.search
                window.location.href = `/#/login?redirect=${encodeURIComponent(currentPath)}`
              }
            }
          ]
        })
      } else {
        const defaultMsg = i18n.t('common.loginExpired')
        console.error(defaultMsg)
        Vue.prototype.$message.error({
          message: defaultMsg,
          duration: 0, // 不自动消失
          showClose: true,
          actions: [
            {
              text: i18n.t('common.reLogin'),
              type: 'primary',
              handler: () => {
                 // 跳转到登录页面
                 const currentPath = window.location.pathname + window.location.search
                 window.location.href = `/#/login?redirect=${encodeURIComponent(currentPath)}`
               }
            }
          ]
        })
      }
      break
    default:
      if (msg) {
        console.error(msg)
        Vue.prototype.$message.error(msg)
      } else {
        const defaultMsg = `服务器异常: ${status}`
        console.error(defaultMsg)
        Vue.prototype.$message.error(defaultMsg)
      }
  }
}

// 创建axios实例
const instance = axios.create({
  baseURL: apiBaseUrl,
  timeout: config.timeout,
  withCredentials: config.withCredentials
})

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  (config) => {
    // 从 Cookie 中获取 CSRF token（页面加载时已确保存在）
    const csrfToken = csrfService.getToken()
    
    // 添加 CSRF token 到请求头
    if (csrfToken) {
      config.headers.Csrf = csrfToken
    }
    
    // 添加国际化locale到请求头
    config.headers['X-Trangpt-Locale'] = i18n.locale
    
    // 在开发环境下添加dev参数到header中
    if (isDev) {
      config.headers.Dev = 'true'
    }
    
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    if (successCode.indexOf(response.data.statusCode) > -1) {
      return Promise.resolve(response.data)
    } else {
      return Promise.reject(response.data)
    }
  },
  (error) => {
    const { response, message: msg } = error
    if (response) {
      netErrorHandle(response.status, response.data?.error, response.data?.message)
      return Promise.reject(response.data)
    } else {
      if (msg && msg.indexOf('timeout') > -1) {
        const timeoutMsg = '请求超时，请稍后重试'
        console.error(timeoutMsg)
        Vue.prototype.$message.error(timeoutMsg)
        return Promise.reject(error)
      } else if (!window.navigator.onLine) {
        // 通知断网
        const networkMsg = '网络异常'
        console.error(networkMsg)
        Vue.prototype.$message.error(networkMsg)
        return Promise.reject(error)
      } else {
        // 其他未知错误
        const unknownMsg = '请求失败，请稍后重试'
        console.error('未知错误:', error)
        Vue.prototype.$message.error(unknownMsg)
        return Promise.reject(error)
      }
    }
  }
)

export default instance